// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/index'


//iview
import ViewUI from 'view-design'
import iView from 'iview';
import 'iview/dist/styles/iview.css';

import weui from 'weui.js'
import 'weui'


import '../static/js/mobile_terminal-width'
// import '../static/js/jweixin-1.3.2'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false

//记得安装后需要使用起来!!!!!!!!!!
Vue.use(VueResource)
Vue.use(VueCookies)
Vue.use(ViewUI)
Vue.use(iView);
//注册vuex
Vue.prototype.$store = store;
//注册全局weui
Vue.prototype.$weui = weui;
// Vue.prototype.$cookies = VueCookies;

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    next();
  }),
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: {
      App
    },
    template: '<App/>'
  })



// WEBPACK FOOTER //
// ./src/main.js